import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverRoundDifferencePouchOperationEntity } from '../../domain/entities/DriverRoundDifferencePouchOperationEntity'

export class DriverRoundDifferencePouchOperationModel extends DriverRoundDifferencePouchOperationEntity {
  constructor(dataDto: DriverRoundDifferencePouchOperationModel) {
    super()
    mapEntityProperties<DriverRoundDifferencePouchOperationEntity>(this, dataDto)
  }
}
